import { mdlServiceResponse } from "../models/service-models/common/ServiceResponse";
import { mdlHotelListRequest } from "../models/service-models/hotel/HotelListRequest";
import { mdlHotelListResponse } from "../models/service-models/hotel/HotelListResponse";
import { mdlHotelRoomListRequest } from "../models/service-models/hotel/HotelRoomListRequest";
import { mdlHotelRoomListResponse } from "../models/service-models/hotel/HotelRoomListResponse";
import { mdlHotelRoomTypeListRequest } from "../models/service-models/hotel/HotelRoomTypeListRequest";
import { mdlHotelRoomTypeListResponse } from "../models/service-models/hotel/HotelRoomTypeListResponse";
import { mdlHotelRoomAndTypeListRequest } from "../models/service-models/hotel/HotelRoomAndTypeListRequest";
import { mdlHotelRoomAndTypeListResponse } from "../models/service-models/hotel/HotelRoomAndTypeListResponse";
import { GetResponse } from "../utils/ApiClient";
import { mdlHotelRoomDeleteRequest } from "../models/service-models/hotel/HotelRoomDeleteRequest";
import { mdlRoomTypeListRequest } from "../models/service-models/hotel/RoomTypeListRequest";
import { mdlRoomTypeListResponse } from "../models/service-models/hotel/RoomTypeListResponse";
import { mdlRoomListRequest } from "../models/service-models/hotel/RoomListRequest";
import { mdlRoomListResponse } from "../models/service-models/hotel/RoomListResponse";
import { mdlRoomAndTypeListResponse } from "../models/service-models/hotel/RoomAndTypeListResponse";
import { mdlRoomAndTypeListRequest } from "../models/service-models/hotel/RoomAndTypeListRequest";
import { mdlHotelNotConfirmDeleteRequest } from "../models/service-models/notConfirm/HotelNotConfirmDeleteRequest";
import { mdlHotelNotConfirmDeleteResponse } from "../models/service-models/notConfirm/HotelNotConfirmDeleteResponse";
import { mdlHotelNotConfirmCreateRequest } from "../models/service-models/notConfirm/HotelNotConfirmCreateRequest";
import { mdlHotelNotConfirmCreateResponse } from "../models/service-models/notConfirm/HotelNotConfirmCreateResponse";
import { mdlHotelNotConfirmListResponse } from "../models/service-models/notConfirm/HotelNotConfirmListResponse";
import { mdlHotelNotConfirmListRequest } from "../models/service-models/notConfirm/HotelNotConfirmListRequest";
import { mdlNotConfirmListRequest } from "../models/service-models/notConfirm/NotConfirmListRequest";
import { mdlNotConfirmListResponse } from "../models/service-models/notConfirm/NotConfirmListResponse";
import { mdlNotConfirmAddRequest } from "../models/service-models/notConfirm/NotConfirmAddRequest";
import { mdlNotConfirmAddResponse } from "../models/service-models/notConfirm/NotConfirmAddResponse";
import { mdlNotConfirmCreateRequest } from "../models/service-models/notConfirm/NotConfirmCreateRequest";
import { mdlHotelNotConfirmCopyToOtherHotelsRequest } from "../models/service-models/notConfirm/HotelNotConfirmCopyToOtherHotelsRequest";
import { mdlBaseOperationResponse } from "../models/service-models/common/BaseOperationResponse";
import { mdlHotelRoomAndTypeDeleteRequest } from "../models/service-models/hotel/HotelRoomAndTypeDeleteRequest";
import { mdlHotelRoomAndTypeDeleteResponse } from "../models/service-models/hotel/HotelRoomAndTypeDeleteResponse";
import { mdlHotelRoomDeleteResponse } from "../models/service-models/hotel/HotelRoomDeleteResponse";
import { mdlHotelRoomCreateRequest } from "../models/service-models/hotel/HotelRoomCreateRequest";
import { mdlHotelRoomCreateResponse } from "../models/service-models/hotel/HotelRoomCreateResponse";
import { mdlHotelRoomTypeCreateRequest } from "../models/service-models/hotel/HotelRoomTypeCreateRequest";
import { mdlHotelRoomTypeCreateResponse } from "../models/service-models/hotel/HotelRoomTypeCreateResponse";
import { mdlHotelRoomTypeCopyRequest } from "../models/service-models/hotel/HotelRoomTypeCopyRequest";
import { mdlHotelRoomTypeCopyResponse } from "../models/service-models/hotel/HotelRoomTypeCopyResponse";
import { mdlHotelRoomCopyRequest } from "../models/service-models/hotel/HotelRoomCopyRequest";
import { mdlHotelRoomCopyResponse } from "../models/service-models/hotel/HotelRoomCopyResponse";
import { mdlHotelRoomAndTypeCopyRequest } from "../models/service-models/hotel/HotelRoomAndTypeCopyRequest";
import { mdlHotelRoomAndTypeCopyResponse } from "../models/service-models/hotel/HotelRoomAndTypeCopyResponse";
import { mdlHotelRoomAndTypeCreateRequest } from "../models/service-models/hotel/HotelRoomAndTypeCreateRequest";
import { mdlHotelRoomAndTypeCreateResponse } from "../models/service-models/hotel/HotelRoomAndTypeCreateResponse";
import { mdlHotelRoomNamesRequest } from "../models/service-models/hotel/HotelRoomNamesRequest";
import { mdlIdCodeNamePair } from "../models/domain/IdCodeNamePair";
import { mdlHotelRoomNamesResponse } from "../models/service-models/hotel/HotelRoomNamesResponse";
import { mdlBaseHotelIdRequest } from "../models/service-models/common/BaseHotelIdRequest";
import { mdlBaseDataResponse } from "../models/service-models/common/BaseDataResponse";
import { mdlBaseDropdownResponse } from "../models/service-models/common/BaseDropdownResponse";
import { mdlHotelRoomTypePrioritySortRequest } from "../models/service-models/hotel/HotelRoomTypePrioritySortRequest";
import { mdlHotelRoomAndTypeUpdateRequest } from "../models/service-models/hotel/HotelRoomAndTypeUpdateRequest";
import { mdlHotelRoomAndTypeUpdateResponse } from "../models/service-models/hotel/HotelRoomAndTypeUpdateResponse";

module DefinitionService {

    export async function CopyHotelRoom(
        pRequest: mdlHotelRoomCopyRequest
    ): Promise<mdlServiceResponse<mdlHotelRoomCopyResponse>> {
        return await GetResponse<mdlServiceResponse<mdlHotelRoomCopyResponse>>(
            "room/copy-room",
            pRequest
        );
    }
    export async function CreateHotelRoom(
        pRequest: mdlHotelRoomCreateRequest
    ): Promise<mdlServiceResponse<mdlHotelRoomCreateResponse>> {
        return await GetResponse<mdlServiceResponse<mdlHotelRoomCreateResponse>>(
            "room/create-room",
            pRequest
        );
    }
    export async function DeleteHotelRoom(
        pRequest: mdlHotelRoomDeleteRequest
    ): Promise<mdlServiceResponse<mdlHotelRoomDeleteResponse>> {
        return await GetResponse<mdlServiceResponse<mdlHotelRoomDeleteResponse>>(
            "room/delete-room",
            pRequest
        );
    }
    export async function HotelRoomList(
        pRequest: mdlHotelRoomListRequest
    ): Promise<mdlServiceResponse<mdlHotelRoomListResponse>> {
        return await GetResponse<mdlServiceResponse<mdlHotelRoomListResponse>>(
            "room/room-list",
            pRequest
        );
    }

    export async function CopyHotelRoomType(
        pRequest: mdlHotelRoomTypeCopyRequest
    ): Promise<mdlServiceResponse<mdlHotelRoomTypeCopyResponse>> {
        return await GetResponse<mdlServiceResponse<mdlHotelRoomTypeCopyResponse>>(
            "room/copy-room-type",
            pRequest
        );
    }

    export async function CreateHotelRoomType(
        pRequest: mdlHotelRoomTypeCreateRequest
    ): Promise<mdlServiceResponse<mdlHotelRoomTypeCreateResponse>> {
        return await GetResponse<mdlServiceResponse<mdlHotelRoomTypeCreateResponse>>(
            "room/create-room-type",
            pRequest
        );
    }

    export async function DeleteHotelRoomType(
        pRequest: mdlHotelRoomDeleteRequest
    ): Promise<mdlServiceResponse<mdlHotelRoomDeleteRequest>> {
        return await GetResponse<mdlServiceResponse<mdlHotelRoomDeleteRequest>>(
            "room/delete-room-type",
            pRequest
        );
    }
    export async function DeleteHotelRoomAndType(
        pRequest: mdlHotelRoomAndTypeDeleteRequest
    ): Promise<mdlServiceResponse<mdlHotelRoomAndTypeDeleteResponse>> {
        return await GetResponse<mdlServiceResponse<mdlHotelRoomAndTypeDeleteResponse>>(
            "room/delete-room-and-type",
            pRequest
        );
    }
    export async function HotelRoomTypeList(
        pRequest: mdlHotelRoomTypeListRequest
    ): Promise<mdlServiceResponse<mdlHotelRoomTypeListResponse>> {
        return await GetResponse<mdlServiceResponse<mdlHotelRoomTypeListResponse>>(
            "room/room-type-list",
            pRequest
        );
    }

    export async function CopyHotelRoomAndType(
        pRequest: mdlHotelRoomAndTypeCopyRequest
    ): Promise<mdlServiceResponse<mdlHotelRoomAndTypeCopyResponse>> {
        return await GetResponse<mdlServiceResponse<mdlHotelRoomAndTypeCopyResponse>>(
            "room/copy-room-and-type",
            pRequest
        );
    }
    export async function HotelRoomAndTypeList(
        pRequest: mdlHotelRoomAndTypeListRequest
    ): Promise<mdlServiceResponse<mdlHotelRoomAndTypeListResponse>> {
        return await GetResponse<mdlServiceResponse<mdlHotelRoomAndTypeListResponse>>(
            "room/room-and-type-list",
            pRequest
        );
    }
    export async function RoomList(
        pRequest: mdlRoomListRequest
    ): Promise<mdlServiceResponse<mdlRoomListResponse>> {
        return await GetResponse<mdlServiceResponse<mdlRoomListResponse>>(
            "room/system-room-list",
            pRequest
        );
    }
    export async function RoomTypeList(
        pRequest: mdlRoomTypeListRequest
    ): Promise<mdlServiceResponse<mdlRoomTypeListResponse>> {
        return await GetResponse<mdlServiceResponse<mdlRoomTypeListResponse>>(
            "room/system-room-type-list",
            pRequest
        );
    }
    export async function RoomAndTypeList(
        pRequest: mdlRoomAndTypeListRequest
    ): Promise<mdlServiceResponse<mdlRoomAndTypeListResponse>> {
        return await GetResponse<mdlServiceResponse<mdlRoomAndTypeListResponse>>(
            "room/system-room-and-type-list",
            pRequest
        );
    }
    export async function NotConfirmSystemMessagesList(
        pRequest: mdlNotConfirmListRequest
    ): Promise<mdlServiceResponse<mdlNotConfirmListResponse>> {
        return await GetResponse<mdlServiceResponse<mdlNotConfirmListResponse>>(
            "notConfirm/system-not-confirm-messages",
            pRequest
        );
    }
    export async function NotConfirmAdd(
        pRequest: mdlNotConfirmAddRequest
    ): Promise<mdlServiceResponse<mdlNotConfirmAddResponse>> {
        return await GetResponse<mdlServiceResponse<mdlNotConfirmAddResponse>>(
            "notConfirm/add",
            pRequest
        );
    }
    export async function NotConfirmCreate(
        pRequest: mdlNotConfirmCreateRequest
    ): Promise<mdlServiceResponse<mdlHotelNotConfirmCreateResponse>> {
        return await GetResponse<mdlServiceResponse<mdlHotelNotConfirmCreateResponse>>(
            "notConfirm/create",
            pRequest
        );
    }
    export async function NotConfirmList(
        pRequest: mdlHotelNotConfirmListRequest
    ): Promise<mdlServiceResponse<mdlHotelNotConfirmListResponse>> {
        return await GetResponse<mdlServiceResponse<mdlHotelNotConfirmListResponse>>(
            "notConfirm/list",
            pRequest
        );
    }
    export async function NotConfirmDelete(
        pRequest: mdlHotelNotConfirmDeleteRequest
    ): Promise<mdlServiceResponse<mdlHotelNotConfirmDeleteResponse>> {
        return await GetResponse<mdlServiceResponse<mdlHotelNotConfirmDeleteResponse>>(
            "notConfirm/delete",
            pRequest
        );
    }
    export async function NotConfirmCopyToOtherHotels(
        pRequest: mdlHotelNotConfirmCopyToOtherHotelsRequest
    ): Promise<mdlServiceResponse<mdlBaseOperationResponse>> {
        return await GetResponse<mdlServiceResponse<mdlBaseOperationResponse>>(
            "notConfirm/copy",
            pRequest
        );
    }
    export async function CreateHotelRoomAndType(
        pRequest: mdlHotelRoomAndTypeCreateRequest
    ): Promise<mdlServiceResponse<mdlHotelRoomAndTypeCreateResponse>> {
        return await GetResponse<mdlServiceResponse<mdlHotelRoomAndTypeCreateResponse>>(
            "room/create-room-and-type",
            pRequest
        );
    }
    export async function UpdateHotelRoomAndType(
        pRequest: mdlHotelRoomAndTypeUpdateRequest
    ): Promise<mdlServiceResponse<mdlHotelRoomAndTypeUpdateResponse>> {
        return await GetResponse<mdlServiceResponse<mdlHotelRoomAndTypeUpdateResponse>>(
            "room/update-room-and-type",
            pRequest
        );
    }

    export async function HotelRoomNames(
        pRequest: mdlHotelRoomNamesRequest
    ): Promise<mdlServiceResponse<mdlHotelRoomNamesResponse>> {
        return await GetResponse<mdlServiceResponse<mdlHotelRoomNamesResponse>>(
            "room/get-room-names",
            pRequest
        );
    }

    export async function RoomTypeNameList(
        pRequest: mdlBaseHotelIdRequest
    ): Promise<mdlServiceResponse<mdlBaseDataResponse<Array<mdlBaseDropdownResponse>>>> {
        return await GetResponse<mdlServiceResponse<mdlBaseDataResponse<Array<mdlBaseDropdownResponse>>>>(
            "room/get-room-type-names",
            pRequest
        );
    }
    export async function RoomTypePrioritySort(
        pRequest: mdlHotelRoomTypePrioritySortRequest
    ): Promise<mdlServiceResponse<mdlBaseOperationResponse>> {
        return await GetResponse<mdlServiceResponse<mdlBaseOperationResponse>>(
            "room/room-type-priority-sort",
            pRequest
        );
    }
}
export { DefinitionService };
